import { render } from "./FileView.vue?vue&type=template&id=63d23d8a&scoped=true"
import script from "./FileView.vue?vue&type=script&lang=js"
export * from "./FileView.vue?vue&type=script&lang=js"

import "./FileView.vue?vue&type=style&index=0&id=63d23d8a&scoped=true&lang=scss"

import exportComponent from "/tmp/ee6909f6-e1a9-41e2-8541-cccc71f1c53b/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d23d8a"]])

export default __exports__